import React, { useEffect, useState } from 'react';

import { SOSemergencyEnableButton } from '../../components/common/SOSemergencyEnableButton';
import SearchBox from '../../components/common/searchBox';

import {
    clearData,
    missedRx3x4xRemovingPageNumber,
    fetchMissedRx3x4x
} from '../../services/slices/dispense/missedRx3x4x';

import { useAuthSelector } from '../../services/selectors/authSelector';
import { useAllSelector } from '../../services/selectors/allSelector';
import { ErrorMessages } from '../../components/error/errorMessages';

import * as routeNames from '../../routes/routeName';
import * as Icons from '../../assets/svg/icons';
import * as Common from '../../components/common';
import * as Hooks from '../../hooks';
import * as Loading from '../../components/common/loader';

const Updates3x4x = () => {
    const dispatch = Hooks.useCustomDispatch();
    const navigate = Hooks.useCustomNavigate();
    const { pharmacyId } = useAuthSelector();
    const { missedRx3x4xResponse } = useAllSelector();

    const [loading, setLoading] = useState(false);
    const [apiCallMade, setApiCallMade] = useState(false);

    useEffect(() => {
        if (pharmacyId) {
            setLoading(true)
            if (!apiCallMade) {
                dispatch(clearData())
                dispatch(missedRx3x4xRemovingPageNumber())
                dispatch(fetchMissedRx3x4x({
                    page: 1,
                    pharmacy_id: pharmacyId,
                    setLoading: setLoading
                }))
                setApiCallMade(true)
            }
        }
        return () => { }
    }, [])

    const getReasonColor = (reason) => {
        switch (reason) {
            case 'RE':
                return 'bg-red-100 text-red-800';
            case 'RC':
                return 'bg-yellow-100 text-yellow-800';
            case 'RR':
                return 'bg-blue-100 text-blue-800';
            case 'RU':
                return 'bg-purple-100 text-purple-800';
            default:
                return 'bg-gray-100 text-gray-800';
        }
    };

    const getReasonText = (reason) => {
        // Return the actual API reason code instead of full words
        return reason || '';
    };

    return (
        <>
            {/* <div className="app-wrapper flex justify-center">
                <div className="app-screen no-shades w-full xl:w-3/12 lg:w-4/12 md:w-5/12 sm:w-6/12 h-full overflow-x-hidden">
                    <div className='flex items-center justify-center'>
                        <SOSemergencyEnableButton />
                    </div>

                    <div className="relative p-4">
                        <div className="card bg-white p-4 rounded-lg shadow-sm">
                            <div className="flex items-center justify-between gap-3">
                                <div>
                                    <Common.TopBar pharmacyId={pharmacyId} />
                                </div>
                                <div className='flex items-center justify-center btnnn pt-4' onClick={() => navigate(`${routeNames.updates}`)}>
                                    <Icons.HomeIcon />
                                </div>
                            </div>
                        </div>

                        <div className="title-row my-2">
                            <h1 className="text-xl font-bold">3x 4x Updates</h1>
                        </div>

                        <div className="flex gap-3 mb-3">
                            <SearchBox pharmacyId={pharmacyId} />
                        </div> */}

                        <div className="missed-rx-list">
                            {(missedRx3x4xResponse?.loading && loading) ? (
                                <div className='flex justify-center h-96'>
                                    <Loading.LoadingView />
                                </div>
                            ) : missedRx3x4xResponse?.error !== null ? (
                                <div className='flex justify-center pb-4 mb-4'>
                                    <ErrorMessages error={'Oops! Got an issue while fetching Data.Please try again!'} />
                                </div>
                            ) : (missedRx3x4xResponse?.data?.length === 0 && !missedRx3x4xResponse?.loading) ? (
                                <p className='flex  pb-4 pt-3 h-96 text-gray-500'>No data available.</p>
                            ) : (
                                missedRx3x4xResponse?.data?.map((item, index) => (
                                    <div key={index} className="card bg-white px-4 py-3 rounded-lg shadow-sm mb-3" id={`patientCard-${index}`}>
                                        {/* Patient Details Header */}
                                        <div className="flex">
                                            <div className="flex items-center gap-2">
                                                <h2 className="text-lg font-medium uppercase">
                                                    {item.patient_name}
                                                </h2>
                                            </div>
                                        </div>

                                        {/* Patient Info - matching flexi delivery style */}
                                        <p className="text-xs text-gray-400 my-1 break-all" style={{ fontSize: "10px" }}>
                                            PHN: {item.phn} | RX: {item.rxnumber}
                                        </p>

                                        {/* Drug Information */}
                                        <div className="mt-2 mb-2 break-all">
                                            <div className="p-2 rounded-md" style={{ backgroundColor: '#f8f9fa', border: '1px solid lightgray' }}>
                                                {/* <div className='flex gap-2 justify-between items-center'>
                                                    <div className='flex gap-2'>
                                                        <p className="text-sm font-normal text-white rounded-md p-1" style={{ fontSize: '12px', height: '29px', background: 'black', paddingLeft: '10px', paddingRight: '10px' }}>
                                                            {item.rxnumber}
                                                        </p>
                                                        {item.rx_stop && (
                                                            <p className="text-sm font-medium text-yellow-800 bg-yellow-100 border border-yellow-200 rounded-md px-2 p-1" style={{ fontSize: '12px', height: '29px' }}>
                                                                STOP: {item.rx_stop}
                                                            </p>
                                                        )}
                                                        {item.rx_stat && (
                                                            <p className="text-sm font-medium text-green-800 bg-green-100 border border-green-200 rounded-md px-2 p-1" style={{ fontSize: '12px', height: '29px' }}>
                                                                STAT: {item.rx_stat}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div> */}

                                                <div className="">
                                                    <p className="text-sm font-medium text-gray-800 mb-1">
                                                        {item.drug}
                                                    </p>
                                                    <p className="text-xs text-gray-600 mb-2">
                                                        {item.sig}
                                                    </p>
                                                </div>

                                                {/* Missed Dates Section */}
                                                <div className="mt-3 pt-3 border-t">
                                                    <h4 className="font-medium text-sm text-gray-700 mb-2">Missed</h4>
                                                    <div className="grid grid-cols-2 gap-2">
                                                        {item.dates?.map((dateItem, dateIndex) => (
                                                            <div key={dateIndex} className="flex items-center justify-between bg-white border border-gray-200 p-2 rounded">
                                                                <span className="text-sm text-gray-700">
                                                                    {dateItem.misseddate1 || dateItem.misseddate2 || dateItem.misseddate3 || dateItem.misseddate4}
                                                                </span>
                                                                <span className={`px-2 py-1 rounded text-xs font-medium ${
                                                                    getReasonColor(dateItem.misseddate1Reason || dateItem.misseddate2Reason || dateItem.misseddate3Reason || dateItem.misseddate4Reason)
                                                                }`}>
                                                                    {getReasonText(dateItem.misseddate1Reason || dateItem.misseddate2Reason || dateItem.misseddate3Reason || dateItem.misseddate4Reason)}
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                {/* Acknowledgement Info */}
                                                {/* <div className="mt-2 pt-2 border-t">
                                                    {item.acknowledge_by_name && (
                                                        <p className="text-xs text-gray-500 mt-1">
                                                            Acknowledged by: {item.acknowledge_by_name}
                                                        </p>
                                                    )}
                                                    {item.acknowledge_at && (
                                                        <p className="text-xs text-gray-500">
                                                            At: {item.acknowledge_at}
                                                        </p>
                                                    )}
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>

                    {/* </div>
                </div>
            </div> */}
        </>
    );
};

export default Updates3x4x;
